import { Button, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import operations from "./ducks/operations.js";

const StyledContainer = styled("div")(({ theme }) => ({
    margin: "0 auto",
    marginTop: "10%",
    position: "relative",
    alignItems: "center",
    borderRadius: "3px",
    "&:focus": {
        outline: "none",
    },
    width: "700px",
    height: "200px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
}));

const StyledHeader = styled("h4")(() => ({
    marginTop: "45px",
    textAlign: "left",
    fontSize: "18px",
    marginLeft: "24px",
}));

const StyledModalContent = styled(Typography)(() => ({
    marginTop: "45px",
    textAlign: "left",
    fontSize: "18px",
    marginLeft: "24px",
}));

const StyledButtonWrapper = styled("div")(() => ({
    position: "absolute",
    bottom: 24,
    right: 24,
}));

const AdImportModal = ({ adImportResponse, closeModal, modalOpen }) => {
    const [processing, setProcessing] = useState(false);

    const onAdImportSubmit = async () => {
        setProcessing(true);
        const status = await operations.adImport();
        if (status >= 200 && status < 300) {
            adImportResponse(true);
        } else {
            adImportResponse(false);
        }
        setProcessing(false);
        closeModal();
    };

    const onExitModal = () => {
        setProcessing(false);
        closeModal();
    };

    return (
        <Modal
            open={modalOpen}
            onClose={() => onExitModal()}
            style={{
                height: "60vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10vh",
            }}
        >
            <StyledContainer>
                <StyledHeader>AD Import</StyledHeader>
                <StyledModalContent>
                    Are you sure you want to import user records from Active Directory?
                </StyledModalContent>
                <StyledButtonWrapper>
                    <Button
                        style={{ display: "inline-block", marginLeft: "10px" }}
                        variant="outlined"
                        onClick={() => onExitModal()}
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{ display: "inline-block", marginLeft: "10px" }}
                        variant="contained"
                        color="primary"
                        disabled={processing}
                        onClick={() => onAdImportSubmit()}
                    >
                        Submit
                    </Button>
                </StyledButtonWrapper>
            </StyledContainer>
        </Modal>
    );
};

export default AdImportModal;
